export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://avecapi.apphub.co.in';
// process.env.REACT_APP_API_BASE_URL || 'https://localhost:7121';

